import React, { useEffect, useState } from "react";
import { Spinner } from "reactstrap";
import { getScoresData } from "../../../actions/feedActions";
import ScoresAutoPopulatedFeedComponent from "./ScoresAutoPopulatedFeedComponent";
import ScoresAutoPopulatedFeedResult from "./ScoresAutoPopulatedFeedResult";

const ScoresFeed = (props) => {
  const { studentId, studentInfo } = props;
  const [scoresFeed, setscoresFeed] = useState([]);
  const [randomImages, setrandomImages] = useState([]);
  useEffect(() => {
    getScoresData(studentId)
      .then((res) => {
        debugger;
        setscoresFeed(res.result.feeds);
        setrandomImages(res.result.randomImages);
      })
      .catch((err) => {});
  }, []);

  console.log("Scores Feed", scoresFeed);
  return scoresFeed.length > 0 ? (
    <div>
      {scoresFeed.map((item, index) =>
        item.test_title == 0 ? (
          <ScoresAutoPopulatedFeedComponent
            key={index}
            key2={item.attempt_id}
            studentInfo={studentInfo}
            studentProgarms={[]}
            topicVideos={[]}
            programRelatedData={[]}
            randomImages={randomImages}
            topicWorkSheets={[]}
            data={item}
            position={"right"}
          />
        ) : item.test_title == 1 ? (
          <ScoresAutoPopulatedFeedComponent
            key={index}
            key2={item.attempt_id}
            studentInfo={studentInfo}
            studentProgarms={[]}
            topicVideos={[]}
            programRelatedData={[]}
            randomImages={randomImages}
            topicWorkSheets={[]}
            data={item}
            position={"left"}
          />
        ) : item.test_title == 2 ? (
          <ScoresAutoPopulatedFeedResult
            key2={index}
            studentInfo={studentInfo}
            studentProgarms={[]}
            programRelatedData={[]}
            data={item}
          />
        ) : null
      )}
    </div>
  ) : (
    <Spinner style={{ margin: "30vh auto" }} color="dark" />
  );
};

export default ScoresFeed;
